module.exports = __webpack_public_path__ + "static/dosing-graphic-keytruda-mobile_rev1-ef07943d1f6db66269a971613f9378de.png";